import { useMarkAsReadMutation } from '@/store/query/notification';
import { Button } from '@chakra-ui/react';

export const GoToInterviewButton = ({
  interviewUrl,
  notification,
  buttonText = 'Go to interview',
  ...props
}) => {
  const [markAsRead] = useMarkAsReadMutation();
  const handleReviewCandidate = () => {
    markAsRead({ id: notification?.id });
    window.open(interviewUrl, '_self');
  };

  return (
    <Button variant="primary" onClick={handleReviewCandidate} {...props}>
      {buttonText}
    </Button>
  );
};
